import React from "react";

import { StyledSVG } from "../StyledIcon";

export const OwnershipIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <path
        d="M4.46156 38L11.4154 33.3391C11.698 33.1497 12.0241 33.0355 12.3631 33.0073L24.8142 31.9714C25.2087 31.9386 25.5846 31.7894 25.8943 31.5428L37.1635 22.5678C37.6616 22.1711 37.8457 21.4975 37.6185 20.9025V20.9025C37.2804 20.0168 36.2017 19.6822 35.4216 20.221L27.1007 25.9683C26.7666 26.199 26.3701 26.3227 25.964 26.3227H18.8252C17.88 26.3227 17.1138 25.5564 17.1138 24.6113V24.6113C17.1138 23.9788 17.4627 23.3978 18.0211 23.1006L24.8022 19.491C25.182 19.2888 25.4193 18.8936 25.4193 18.4634V18.4634C25.4193 17.7148 24.7229 17.1608 23.9934 17.3292L11.8905 20.1231C11.3573 20.2461 10.8979 20.5822 10.6192 21.0531L8.51782 24.6032C7.85711 25.7194 6.85248 26.5914 5.65448 27.0886L2 28.6053"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 3L22.1226 6.45492H25.7553L22.8164 8.59017L23.9389 12.0451L21 9.90983L18.0611 12.0451L19.1836 8.59017L16.2447 6.45492H19.8774L21 3Z"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27 26L31.1261 19.5147C31.6743 18.653 32.8478 18.3108 33.4852 19.1087C33.8738 19.5951 34.1193 20.195 33.9406 20.8571"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 26L24.7468 24.0086C25.154 22.9228 26.4257 22.3713 27.3768 23.0347C27.7413 23.289 28 23.5342 28 23.7143"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
